import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class GlobalTrimService {
    private initialized = false;

    initialize() {
        if (this.initialized) return;

        // Handle all text inputs on focusout
        document.addEventListener('focusout', this.handleInputTrim.bind(this), true);

        this.initialized = true;
    }

    private handleInputTrim(event: Event) {
        const target = event.target as HTMLInputElement | HTMLTextAreaElement;

        // Only process text inputs and textareas
        if (this.shouldTrimInput(target)) {
            const originalValue = target.value;
            const trimmedValue = originalValue.trim();

            if (originalValue !== trimmedValue) {
                target.value = trimmedValue;

                // Trigger Angular change detection
                this.triggerAngularEvents(target);
            }
        }
    }

    private shouldTrimInput(element: Element): element is HTMLInputElement | HTMLTextAreaElement {
        if (!element) return false;

        const tagName = element.tagName.toLowerCase();

        if (tagName === 'textarea') return true;

        if (tagName === 'input') {
            const inputType = (element as HTMLInputElement).type.toLowerCase();
            // Trim text-based inputs only
            return ['text'].includes(inputType);
        }

        return false;
    }

    private triggerAngularEvents(target: HTMLInputElement | HTMLTextAreaElement) {
        // Dispatch events to trigger Angular's change detection
        target.dispatchEvent(new Event('input', { bubbles: true }));
    }
}